import type { Impact } from '@/api/models/impactModels';

import ImpactMapWeb from './ImpactMapWeb';

export interface ImpactMapProps {
  showDonation: (item: Impact) => void;
}

const ImpactMap = ({ showDonation }: ImpactMapProps) => <ImpactMapWeb showDonation={showDonation} />;

export default ImpactMap;